module.exports = __webpack_public_path__ + "static/media/RightLong.a340b3c4.svg";